import React from 'react';
import { bool, func, string } from 'prop-types';
import { Grid, SvgIcon, IconButton, styled } from '@nextiva/next-ui-components';

const CloseIcon = () => {
  return (
    <SvgIcon width="16.634" height="16.635" viewBox="0 0 16.634 16.635">
      <g
        id="Group_5357"
        data-name="Group 5357"
        transform="translate(0.707 0.707)"
      >
        <path
          id="Path_42"
          data-name="Path 42"
          d="M0,0V21.525"
          transform="translate(0 0) rotate(-45)"
          fill="none"
          stroke="#8199b4"
          strokeWidth="2"
        />
        <path
          id="Path_43"
          data-name="Path 43"
          d="M0,0V21.525"
          transform="translate(15.22 0) rotate(45)"
          fill="none"
          stroke="#8199b4"
          strokeWidth="2"
        />
      </g>
    </SvgIcon>
  );
};

const Header = styled('div')`
  display: flex;
  align-items: center;
  width: 40vw;
  height: 5rem;
  padding: 1.8rem;
  border-bottom: 1px solid #c9e2e2;
  background-color: rgb(255, 255, 255);
  font-size: 24px;
  font-weight: 600;
  line-height: 29px;
  color: #232649;
`;

const CloseBtn = styled(IconButton)`
  svg {
    width: 16px;
    height: 16px;
  }
`;

const DrawerHeader = ({ title, closeDrawer, TitleComponent }) => {
  return (
    <Header>
      <Grid container spacing={2} alignItems="center">
        <Grid
          container
          item
          md={10}
          xs={8}
          data-testid="PlatformAdminUI-TeamVoiceSettings-Drawer-Header"
        >
          {title}
          {TitleComponent && <TitleComponent />}
        </Grid>
        <Grid item md={2} xs={4} align="right">
          <CloseBtn
            onClick={closeDrawer}
            data-testid="PlatformAdminUI-TeamVoiceSettings-Drawer-CloseButton"
          >
            <CloseIcon />
          </CloseBtn>
        </Grid>
      </Grid>
    </Header>
  );
};

DrawerHeader.propTypes = {
  TitleComponent: bool,
  closeDrawer: func,
  title: string,
};

DrawerHeader.defaultProps = {
  TitleComponent: false,
  closeDrawer: () => {},
  title: '',
};

export default DrawerHeader;
